import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
// import Separator from "@material-ui/icons/LinearScale";
import Bullet from "@material-ui/icons/DragIndicator";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";

import servicesStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/servicesStyle.jsx";

function SectionServices(props) {
  const { classes } = props;
  return (
    <div className={classes.services}>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(
            classes.mlAuto,
            classes.mrAuto,
            classes.textCenter
          )}
        >
          <h2 className={classes.title}>What we offer</h2>
          <h5 className={classes.description}>
            Kinos’s partnership culture, our commitment to excellence and uncompromising integrity makes us an excellent choice for investors with a long-term vision.
          </h5>

          <h5 className={classes.description}>Our client´s interest first is the core of our asset management philosophy.
              We also custom tailor your investment strategies to clients’ specific needs.
          </h5>
          <h5 className={classes.description}>We develop ideas and analysis that drive new perspectives, new opportunities and new paths to growth.</h5>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem md={6} sm={6}>
          <InfoArea
            title="ADVISORY & TRANSACTION SERVICES"
            description={
              <span>
                <p>
                  The real estate requirements of today's businesses are increasingly complex, and require a higher level of strategy and sophistication. At Kinos, we help our clients make bespoke decisions to align and improve their real estate with their overall business performance and objectives.
As advisory and transactions firm in the Spain and Portugal, Kinos offers unique insight, experience and solutions to serve the needs of real estate occupiers and investors.
Kinos is capable of providing strategic solutions for acquisition, disposition and financing/refinancing situations. Solutions will include advising on strategic servicing of non-recourse loans, loan restructuring and asset enhancement.
For every engagement in every market across the Spain and Portugal , our strategy-led approach seamlessly brings together our advisory services and leading execution services to provide our clients with the information they need to anticipate opportunities, seize competitive advantage and execute the best possible real estate strategies.
                </p>

              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>
        <GridItem md={6} sm={6}>
          <InfoArea
            title="PROPERTY MANAGEMENT"
            description={
              <span>
                <p>
                  Kinos provides a consolidated and accurate view of your property portfolio data, as well as comprehensive  estates management.
We understand that, as an investor or asset manager, your priority is an office building that works. This is why we work with the best systems and the best people.
Kinos  will consider same-boat investment or role as pure brokerage service provider when necessary.  Kinos advisory is also capable of providing variety of solutions for reducing operational and fund level expenses to maximize the cash flow from the assets.
Our market-leading data analytics and insight will provide you with a clear view of your real estate portfolio, facilitating your property management by enabling you to easily track performance and work-in-progress activity.
Using powerful analytics tools, our network of experts will help you to identify efficiencies while aligning your real estate more closely with your corporate objectives.

                </p>

              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>
        <GridItem md={6} sm={6}>
          <InfoArea
            title="RELATIONSHIPS"
            description={
              <span>
                <p>
                  Building Relationships. Business are built on relationships.
In a global world that is more connected than ever before, businesses are ever-increasingly built on relationships. Kinos is working all time building good relationships with investors, owners, others brokers , governments, institutions, employees, service providers, other professionals suppliers, and stakeholders. Having good relationships can make the difference between the success and failure of a business.
Relationships Built on Excellence
Our Kinos team and network is dedicated to providing investors and business leaders with customized solutions to help them successfully navigate the ever-evolving commercial real estate market.
Our success is built on developing long-term relationships, practicing consistent financial discipline, and providing our clients dedicated service and access to our best-in-class, comprehensive suite of solutions and management tools.
                </p>

              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>
        <GridItem md={6} sm={6}>
          <InfoArea
            title="PROPERTY SALES"
            description={
              <span>
                <p>
                  Wealth Management & Brokerage.
Kinos provide many of the most sophisticated investors with a global platform ( Torus Network)  driven by local investment talent.
To achieve strong growth and high returns, we seek to build leadership positions in high value-added services for our clients. For example, we have substantially increased the number of professionals network  to improve and expand our ability to execute sales and acquisitions In the market, we structure and execute small, medium and large transactions for  family offices or institutional investors, pension funds and corporate clients. In asset management, we emphasize equity and alternative investment assets and use our international network to build a full asset management.
Kinos professionals network provides services such as sourcing, acquisition, underwriting and due diligence of distressed and performing real estate and loan assets, asset management, portfolio management and disposition across various property types.
                </p>

              </span>
            }
            icon={Bullet}
            iconColor="rose"
          />
        </GridItem>

        <GridItem md={6} sm={6}
          className={classNames(
            classes.mlAuto,
            classes.mrAuto,
            classes.textCenter
          )}
          >
          <h3 className={classes.title}>Investment strategies</h3>
            <span>
              <p>
                <h5>Management of JV or Development Process</h5>
                <h5>Financial Operating Modelling</h5>
                <h5>Budgeting and control</h5>
                <h5>Legal Structuring and Specifications</h5>
                <h5>Tech-Enabled Interaction</h5>
                <h5>Financial Reporting</h5>
                <h5>Operation Reporting</h5>
                <h5>Marketing Strategy</h5>
                <h5>Sales Strategy</h5>
                <h5>Life Cycle Cost Analysis</h5>
                <h5>Asset Positioning</h5>
                <h5>Exit Strategy</h5>
              </p>

            </span>
        </GridItem>

        <GridItem md={6} sm={6}
          className={classNames(
            classes.mlAuto,
            classes.mrAuto,
            classes.textCenter
          )}
          >
          <h3 className={classes.title}>Investment channels</h3>
            <span>

                <h6>Direct Investments</h6>
                <h5>In real estate assets </h5>
                <h5>In projects</h5> 
                <h6>Through Intermediaries</h6>
                <h5>InvestmentManagers </h5>
                <h5>Private equity funds </h5>
                <h5>Infrastructure funds</h5> 
                <h5>Socimis</h5> 
                <h5>Reits</h5> 
                <h6>Other pooled investment vehicles...</h6>

            </span>
        </GridItem>

      </GridContainer>
    </div>
  );
}

export default withStyles(servicesStyle)(SectionServices);
